import React from 'react';
import "./TournamentHistory.css"
import TournamentFilter from "./TournamentFilter";
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { apiService } from '../../common/apiCallService.js'
import Loading from '../Loading';
import { domain, baseUrl } from "../../common/config.js"
import TournamentHistoryTable from './TournamentHistoryTable';
import MediaQuery from 'react-responsive';
import i18next from 'i18next'

class TournamentHistoryFullScreen extends React.Component {
    constructor(props) {
        super(props);
        let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = this.props.activeTournyFilter
        this.state = {
            loading: true,
            fullScreenLoading: false,
            tournamentAggResult: {},
            tournamentFeed: [],
            pageNumber: 0,
            buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType,
            tournamentTypeList: props.tournamentTypeList,
            tournamentSpeedList: props.tournamentSpeedList
        }
    }

    toggleOpenDetails = () => {
        this.props.toggleTournamentHistoryDetails(!this.props.tournamentHistoryFlag)
        this.props.setTournyDtls(this.state.tournamentAggResult, this.state.tournamentFeed)
    }

    toggleFullScreen = () => {
        this.props.toggleTournamentHistoryFullScreen(!this.props.tournamentHistoryFullScreenFlag)
        this.props.setTournyDtls(this.state.tournamentAggResult, this.state.tournamentFeed.slice(0, 5))
    }

    nextPage = (pageNumber, tournyPlayed) => {
        this.setState({ fullScreenLoading: true })
        this.setState({ pageNumber: pageNumber })
        this.getHandHistory(pageNumber)
    }

    componentWillReceiveProps(prevProps, prevState) {
        let mysatsGame = this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType
        if (mysatsGame != this.state.feedGameType) {
            let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = prevProps.activeTournyFilter
            this.setState({
                tournamentAggResult: prevProps.tournyDtls.aggResult.length > 0 && prevProps.tournyDtls.aggResult[0],
                tournamentFeed: prevProps.tournyDtls.tournyDtls.length > 0 && prevProps.tournyDtls.tournyDtls,
                pageNumber: 0,
                buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType,
                trnyType: prevProps.tournamentTypeList.length > 0 ? prevProps.tournamentTypeList[0].value : null,
                gameSpeed: prevProps.tournamentSpeedList.length > 0 ? prevProps.tournamentSpeedList[0].value : null,
                tournamentTypeList: prevProps.tournamentTypeList,
                tournamentSpeedList: prevProps.tournamentSpeedList
            })
        }
    }

    saveSetting = (data) => {
        this.setState({loading:true})
        data.feedGameType = this.state.feedGameType
        this.props.setTournyFilter(data)
        this.setState({ pageNumber: 0 })
        this.setState(data, () => this.getHandHistory(0))
    }
    
    componentDidMount() {
        this.getHandHistory(this.state.pageNumber)
    }

    getHandHistory = (pageNumber) => {
        let { gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange } = this.state
        apiService(baseUrl + '/tournamentFeed/getTournamentFeedDtls', {
            accountName: localStorage.getItem('accountName'),
            limit: 15 * (pageNumber + 1),
            offset: 0,
            gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange, pageNumber
        }, (data) => {
            this.setState({ tournamentAggResult: data.aggResult.length > 0 && data.aggResult[0], tournamentFeed: data.tournyDtls.length > 0 && data.tournyDtls, loading: false, fullScreenLoading: false })
        }, (data) => {
            this.setState({ loading: false, fullScreenLoading: false })
        })
    }

    render() {
        let { tournyPlayed, totalBountyWon, totalfee, totalBuyin } = this.state.tournamentAggResult
        return (
            <div>
                {(this.props.loading || this.state.loading)
                    ? <Loading />
                    :
                    <div>
                        <MediaQuery minWidth={679} > <div className="ms_header">
                            <div className={`container ms_header_content `}>
                                <div className="ms_title ">{i18next.t("lable.tournamentHistory")}
                                <span className="tournamentIconSpan">
                                        <button className="btnDesktopStyle" data-toggle="modal" data-target="#settingModalTournaments">
                                            <FontAwesome name="fa fa-filter" style={{ color: 'white', fontSize: '21px' }} />
                                        </button>
                                        <button style={{marginRight:'0px'}} className="btnDesktopStyle" onClick={this.toggleFullScreen} >
                                            <FontAwesome name="fa fa-times" style={{ color: 'white', fontSize: '21px' }} />
                                        </button>
                                    </span>
                                </div>
                                <div className="p-bottom-10-tournament"><span className="tournamentSubHeaderSpan">{i18next.t("lable.total")} - </span> {i18next.t("lable.tournamentsPlayed")}: {tournyPlayed} - {i18next.t("lable.buyIns")}: ${totalBuyin} - {i18next.t("lable.fees")}: ${totalfee}</div>
                            </div>
                        </div>
                        </MediaQuery>
                        <MediaQuery maxWidth={678} > <div className="ms_header">
                            <div className={`container ms_header_content `}>
                                <div className="ms_title title-tournament-full-margin-top">{i18next.t("lable.tournamentHistory")}
                                <span className="tournamentIconSpan">
                                        <i data-toggle="modal" data-target="#settingModalTournaments" className="fa fa-filter tournamentColor"></i>
                                        <i onClick={this.toggleFullScreen} className="tournamentColor marginLeftIconTornament fa fa-times" ></i>
                                    </span>
                                </div>
                                <div className="p-bottom-10-tournament tournament-font-size tournamentHeadermargin"><span className="tournamentSubHeaderSpan">{i18next.t("lable.total")} - </span> {i18next.t("lable.tournamentsPlayed")}: {tournyPlayed} - {i18next.t("lable.buyIns")}:${totalBuyin} </div>
                            </div>
                        </div>
                        </MediaQuery>
                        <MediaQuery minWidth={951} >
                            <div className="ms_header_tournamnet">
                                <div className={`container ms_header_tournamnet_content `}>
                                    <div className="row background-tournamnet padding-tournamnet-title table-header-tournamnet-full-screen">
                                        <div style={{ marginBottom: "0" }} className="table-header-width margin-bottom-0">

                                            <div className="row table-header-font">
                                                <div style={{ paddingLeft: 0 }} className="col-md-4 col-xs-4" >{i18next.t("lable.tournamentName")}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.buyIn")}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-1 col-xs-1" >{i18next.t("lable.startDate")}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.fees")}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-1 col-xs-1" >{i18next.t("lable.bountiesWon")}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-1 col-xs-1" >{i18next.t("lable.totalPrizes")}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.totalWon")}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </MediaQuery>
                        <div className="tournament-card-wrapper" >
                            {this.state.tournamentFeed.length > 0
                                ? <TournamentHistoryTable
                                    nextPage={this.nextPage}
                                    loading={this.state.fullScreenLoading}
                                    pageNumber={this.state.pageNumber}
                                    tournamentAggResult={this.state.tournamentAggResult}
                                    tournamentFeed={this.state.tournamentFeed}
                                    isFullScreen={true} />
                                : <center> <h3 style={{ padding: '30px' }}>{i18next.t("lable.noDataFoundcngfilter")}</h3></center>
                            }
                            <TournamentFilter
                                buyIn={this.state.buyIn}
                                feedGameType={this.state.feedGameType}
                                gameSubType={this.state.gameSubType}
                                trnyType={this.state.trnyType}
                                gameSpeed={this.state.gameSpeed}
                                dateRange={this.state.dateRange}
                                tournamentTypeList={this.state.tournamentTypeList}
                                saveSetting={this.saveSetting}
                                tournamentSpeedList={this.state.tournamentSpeedList}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
        tournamentHistoryFullScreenFlag: state.multipleReportCards.tournamentHistoryFullScreenFlag,
        activeTournyFilter: state.multipleReportCards.activeTournyFilter,
        myStatSettings: state.multipleReportCards.myStatSettings,
        lang: state.header.lang
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleTournamentHistoryDetails: (data) => dispatch(actions.toggleTournamentHistoryDetails(data)),
        toggleTournamentHistoryFullScreen: (data) => dispatch(actions.toggleTournamentHistoryFullScreen(data)),
        setTournyFilter: (data) => dispatch(actions.setTournyFilter(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TournamentHistoryFullScreen);



/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/TournamentHistoryFullScreen.js
 **/